<template>
  <div class="palette-container" :style="containerStyle">
    <!-- Main palette -->
    <div class="palette mb-3 mt-2" :class="layout" :style="paletteStyle">
      <!-- Color blocks -->
      <div 
        v-for="(color, index) in colors"
        :key="'color-' + index"
        class="color-block"
        :style="colorBlockStyle(color, colors.length - 1 - index)"
      ></div>
      
      <!-- Numbers -->
      <div 
        v-for="(number, index) in numbers"
        :key="'number-' + index"
        class="number"
        :style="numberPosition(numbers.length - 1 - index)"
      >
        {{ number }}
      </div>
    </div>

    <!-- Bottom signature -->
    <div class="signature" :style="signatureStyle">
      {{ signatureText }}
    </div>
  </div>
</template>


<script>
export default {
  props: {
    colors: {
      type: Array,
      required: true,
      validator: value => value.every(c => 
        c.length === 3 && 
        c.every(n => Number.isInteger(n) && 
        n >= 0 && 
        n <= 255
      ))
    },
    numbers: {
      type: Array,
      required: true,
      validator: value => value.every(n => typeof n === 'number')
    },
    signatureText: {
      type: String,
      default: ''
    },
    layout: {
      type: String,
      default: 'vertical',
      validator: value => ['vertical', 'horizontal'].includes(value)
    },
    height: {
      type: Number,
      default: 400,
      validator: value => value > 0
    },
    width: {
      type: Number,
      default: 600,
      validator: value => value > 0
    },
    paletteWidth: {
      type: Number,
      default: 100,
      validator: value => value > 0
    },
    textSize: {
      type: Number,
      default: 14,
      validator: value => value > 0
    },
    textColor: {
      type: String,
      default: '#000'
    }
  },
  computed: {
    containerStyle() {
      return {
        height: this.layout === 'vertical' ? `${this.height}px` : 'auto',
        width: this.layout === 'horizontal' ? `${this.width}px` : 'auto'
      }
    },
    paletteStyle() {
      return {
        width: this.layout === 'vertical' ? `${this.paletteWidth}px` : '100%',
        height: this.layout === 'horizontal' ? `${this.paletteWidth}px` : '100%'
      }
    },
    stepSize() {
      return this.layout === 'vertical' 
        ? this.height / this.colors.length
        : this.width / this.colors.length
    },
  },
  watch: {
    colors: {
      handler(newVal) {
        this.validateNumbersCount(newVal, this.numbers)
      },
      immediate: true
    },
    numbers: {
      handler(newVal) {
        this.validateNumbersCount(this.colors, newVal)
      },
      immediate: true
    }
  },
  methods: {
    validateNumbersCount(colors, numbers) {
      if (numbers.length !== colors.length + 1) {
        console.error(`Numbers array must have exactly ${colors.length + 1} elements`)
      }
    },
    colorBlockStyle(color, index) {
      const baseStyle = {
        backgroundColor: `rgb(${color.join(',')})`,
        position: 'absolute'
      }
      
      if (this.layout === 'vertical') {
        return {
          ...baseStyle,
          height: `${this.stepSize}px`,
          width: '100%',
          top: `${index * this.stepSize}px`,
          'margin-left' : `2px`
        }
      }
      
      return {
        ...baseStyle,
        width: `${this.stepSize}px`,
        height: '100%',
        left: `${index * this.stepSize}px`
      }
    },
    numberPosition(index) {
      const position = {}
      const textOffset = this.textSize / 2
      
      if (this.layout === 'vertical') {
        position.left = `${this.paletteWidth + 7}px`
        position.top = `${index * this.stepSize - textOffset}px`
      } else {
        position.top = `${this.paletteWidth + 7}px`
        position.left = `${index * this.stepSize - textOffset}px`
      }
      
      return {
        ...position,
        color: this.textColor,
        fontSize: `${this.textSize}px`,
        position: 'absolute'
      }
    }
  }
}
</script>

<style scoped>
.palette-container {
  position: relative;
/*  font-family: Arial, sans-serif;*/
}

.palette {
  position: relative;
}

.palette.vertical {
  display: flex;
  flex-direction: column;
}

.palette.horizontal {
  display: flex;
}

.color-block {
  flex: 1;
}

.signature {
  text-align: center;
  width: 100%;
}
</style>